import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocketFormComponent } from '../docket-form/docket-form.component';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrl: './disclaimer.component.scss',
  standalone: false
})
export class DisclaimerComponent {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DisclaimerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  proceed(): void {
    this.dialogRef.close();
    this.dialog.open(DocketFormComponent, {
      width: '1000px',
      maxWidth: '90vw',
      data: {
        selectedoffering: this.data.selectedoffering,
        prereqDocketUrl: this.data.prereqDocketUrl,
        prereqDocketname: this.data.prereqDocketname
      }
    });
  }
}
